
import { Col, DatePicker, Form, Input, Pagination, Row } from "antd";
import dayjs from 'dayjs';

const AttributeFormComponent = ({ feature, field }) => {

    //console.log("AttributeTableComponent feature", feature);
    //console.log("AttributeTableComponent field", field);

    let dateFormat = 'DD//MM/YYYY';

    //Possible Values:"small-integer"|"integer"|"single"|"double"|"long"|"string"|"date"|"oid"|"geometry"|"blob"|"raster"|"guid"|"global-id"|"xml"
    const renderValue = () => {

        let value = feature.attributes[field.name];

        if (value == null)  return <Input value={""} readOnly={true} ></Input>;

        if (field.type == "date") {
            //console.log('new Date(value)',new Date(value))
            return <DatePicker style={{width: '100%'}} defaultValue={dayjs(new Date(value))} format={dateFormat} readOnly={true} disabled={true}/>           
        }
        else if (field.type == "small-integer" || field.type == "small-integer") {
            return <Input value={value} readOnly={true} ></Input>
        }
        else if (field.type == "double" || field.type == "long") {
            let isInteger = Number.isInteger(value);
            if (isInteger) {
                return <Input value={value} readOnly={true} ></Input>
            }
            else {
                return <Input value={value.toFixed(2)} readOnly={true} ></Input>              
            }

        }
        else {
            return <Input value={value} readOnly={true} ></Input>
        }
    }

    return (
        <>
            {renderValue()}
        </>
    )
};

export default AttributeFormComponent;